<template>
  <div class="maxbox">
    <div>
      <div class="top">
        <p>TRDO 代币管理后台</p>
      </div>
      <div class="main">
        <button class="return" @click="goback">
          <img src="@/assets/images/left-arrow.png" alt="" />
        </button>
        <div class="main-content">
          <template v-if="isOwner">

            <!-- 1. 矿机合约地址 → 实时显示在输入框 -->
            <div class="item-box">
              <label>矿机合约地址：</label>
              <input
                type="text"
                v-model="machineContract"
                placeholder="输入矿机合约地址"
              />
              <button @click="setMachineContract">设置矿机合约地址</button>
            </div>

            <!-- 2. 矿机收款地址 → 实时显示在输入框 -->
            <div class="item-box">
              <label>矿机收款地址：</label>
              <input
                type="text"
                v-model="machineOwner"
                placeholder="输入收款地址"
              />
              <button @click="setMachineOwner">设置矿机收款地址</button>
            </div>

            <!-- 3. 修改代币名称 & 符号 → 自动从合约读取 -->
            <div class="item-box">
              <label>代币名称：</label>
              <input
                type="text"
                v-model="tokenName"
                placeholder="如：TORNADO"
              />
              <label>代币符号：</label>
              <input
                type="text"
                v-model="tokenSymbol"
                placeholder="如：TORNADO"
              />
              <button @click="setTokenInfo">修改代币名称/符号</button>
            </div>

            <!-- 手续费管理 -->
            <div class="item-box">
              <label style="color:red;font-weight:bold;">转账手续费设置</label>
              <div style="margin:5px 0;">
                <span>当前状态：{{ feeEnabled ? "✅ 已开启" : "❌ 已关闭" }}</span>
                <button @click="toggleFee" style="background: #ff6600;">
                  {{ feeEnabled ? "关闭手续费" : "开启手续费" }}
                </button>
              </div>

              <div style="margin:5px 0;">
                <label>当前费率：{{ transferFeeRate }} %</label>
                <input
                  type="number"
                  v-model="newFeeRate"
                  placeholder="输入 0-35"
                  style="width:100px;"
                  max="35"
                  min="0"
                />
                <button @click="updateFeeRate" style="background: #28a745;">
                  修改手续费率
                </button>
              </div>
            </div>

            <!-- 权限管理 -->
            <div class="item-box">
              <button @click="safeRenounceOwnership">丢弃所有权（谨慎）</button>
              <button @click="recoverOwnership">恢复所有权</button>
            </div>

          </template>

          <div v-else class="tip">
            您不是合约管理员，无法使用此功能
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ethers } from 'ethers';
import { contractAddress, contractABI } from '@/js/contractwo.js';

export default {
  name: 'TRDOSettings',
  data() {
    return {
      isOwner: false,
      machineContract: '',
      machineOwner: '',
      tokenName: '',
      tokenSymbol: '',
      feeEnabled: false,
      transferFeeRate: 0,
      newFeeRate: 0,
      provider: null,
      signer: null,
      contract: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    async init() {
      await this.connectWallet();
      await this.checkIsOwner();
      await this.loadRealTimeData();
      await this.loadFeeInfo();
    },
    async connectWallet() {
      try {
        if (typeof window.ethereum === 'undefined') {
          alert('请安装MetaMask');
          return;
        }
        this.provider = new ethers.providers.Web3Provider(window.ethereum);
        await this.provider.send('eth_requestAccounts', []);
        this.signer = this.provider.getSigner();
        this.contract = new ethers.Contract(contractAddress, contractABI, this.signer);
      } catch (err) {
        console.error(err);
      }
    },

    // 判断是否为管理员
    async checkIsOwner() {
      const user = await this.signer.getAddress();
      const owner = await this.contract.owner();
      this.isOwner = user.toLowerCase() === owner.toLowerCase();
    },

    // 实时读取：矿机地址 + 代币名称符号
    async loadRealTimeData() {
      try {
        // 读取矿机地址
        const mc = await this.contract.machineContract();
        const mo = await this.contract.machineOwner();
        // 读取合约真实代币名称
        const name = await this.contract.name();
        const symbol = await this.contract.symbol();

        // 自动填入输入框
        this.machineContract = mc;
        this.machineOwner = mo;
        this.tokenName = name;
        this.tokenSymbol = symbol;
      } catch (e) {
        console.error("加载数据失败", e);
      }
    },

    // 加载手续费信息
    async loadFeeInfo() {
      try {
        let enabled = await this.contract.feeEnabled();
        let rate = await this.contract.transferFeeRate();
        this.feeEnabled = enabled;
        this.transferFeeRate = parseInt(rate);
        this.newFeeRate = this.transferFeeRate;
      } catch (e) {
        console.error("加载手续费失败", e);
      }
    },

    // 开关手续费
    async toggleFee() {
      try {
        let tx = await this.contract.toggleFeeEnabled(!this.feeEnabled);
        await tx.wait();
        alert("操作成功！");
        this.loadFeeInfo();
      } catch (e) {
        alert("失败：" + e.message);
      }
    },

    // 修改手续费率
    async updateFeeRate() {
      if (this.newFeeRate < 0 || this.newFeeRate > 35) {
        alert("费率必须在 0-35 之间");
        return;
      }
      try {
        let tx = await this.contract.setTransferFeeRate(this.newFeeRate);
        await tx.wait();
        alert("费率修改成功！");
        this.loadFeeInfo();
      } catch (e) {
        alert("失败：" + e.message);
      }
    },

    // 设置矿机合约地址
    async setMachineContract() {
      if (!ethers.utils.isAddress(this.machineContract)) {
        alert('地址无效');
        return;
      }
      try {
        const tx = await this.contract.setMachineContract(this.machineContract);
        await tx.wait();
        alert('设置成功');
        this.loadRealTimeData();
      } catch (e) {
        alert('失败：' + e.message);
      }
    },

    // 设置矿机收款地址
    async setMachineOwner() {
      if (!ethers.utils.isAddress(this.machineOwner)) {
        alert('地址无效');
        return;
      }
      try {
        const tx = await this.contract.setMachineOwner(this.machineOwner);
        await tx.wait();
        alert('设置成功');
        this.loadRealTimeData();
      } catch (e) {
        alert('失败：' + e.message);
      }
    },

    // 修改代币信息
    async setTokenInfo() {
      try {
        const tx = await this.contract.setTokenInfo(this.tokenName, this.tokenSymbol);
        await tx.wait();
        alert('修改成功');
        this.loadRealTimeData();
      } catch (e) {
        alert('失败：' + e.message);
      }
    },

    // 丢弃所有权
    async safeRenounceOwnership() {
      if (!confirm('确定丢弃所有权？此操作不可逆！')) return;
      try {
        const tx = await this.contract.safeRenounceOwnership();
        await tx.wait();
        alert('已丢弃所有权');
      } catch (e) {
        alert('失败');
      }
    },

    // 恢复所有权
    async recoverOwnership() {
      try {
        const tx = await this.contract.recoverOwnership();
        await tx.wait();
        alert('已恢复所有权');
      } catch (e) {
        alert('失败');
      }
    },
  },
};
</script>

<style scoped>
@import "@/assets/css/settings.css";
@import "@/assets/css/style.css";

.main {
  padding-top: 50px;
}
.item-box {
  margin: 15px 0;
}
input {
  width: 100%;
  padding: 8px;
  margin: 5px 0;
  box-sizing: border-box;
}
button {
  padding: 10px 15px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 5px 0;
}
.tip {
  color: red;
  font-size: 16px;
  text-align: center;
  margin-top: 30px;
}
</style>